import Vue from 'vue';

if (document.getElementById('vue')) {
	/**
	 * Promise Polyfill for Old IE
	 */
	require('es6-promise').polyfill();
	require('fetch-ie8');
	require('array-from');

	/**
	 * Get the Vue instance set up
	 */
	window.Vue = Vue;

	// Register a global custom directive called v-focus
	Vue.directive('focus', {
		// When the bound element is inserted into the DOM...
		inserted: function (el) {
			// Focus the element
			el.focus()
		}
	});

	//Include components and mixins
	window.mixins = require('./vue/mixins');
	window.components = require('./vue/components');
	Vue.mixin(mixins);

	//Init vue
	const app = new Vue({
		el: '#vue',

		data() {
			return {}
		},

		mounted() {

		},
	});
}
